import { render, staticRenderFns } from "./_address.vue?vue&type=template&id=4723431f&"
import script from "./_address.vue?vue&type=script&lang=js&"
export * from "./_address.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports